<template>
	<div style="width: 1400px;margin: 20px auto;background-color: #fff;padding: 30px;" v-html="item.content">

	</div>
</template>

<script>
	export default {
		data() {
			return {
				item: ''
			}
		},
		created() {
            this.item=JSON.parse(this.$route.query.item)
		},
		methods: {
			
		}
	}
</script>

<style lang="scss">

</style>
